import { message, Modal } from "antd";
import useEntities from "hooks/useEntities";
import { deleteEntity } from "./apiFunctions";

export function useRemovePlayerRegistrationModal() {
  const entities = useEntities();

  function showRemovePlayerSeasonRegistrationWithConfirm(record, onSuccess, currentRole) {
    Modal.confirm({
      title: 'Remove Registration',
      content: `Are you sure you want to remove the registration for ${record.Player?.firstName} ${record.Player?.lastName} from ${record.Season?.name}?`,
      okText: 'Remove',
      okType: 'danger',
      okButtonProps: { size: 'small' },
      cancelButtonProps: { size: 'small' },
      onOk: () => {
        return deleteEntity(entities.SeasonPlayerRegistration, record.seasonPlayerRegistrationId, currentRole)
          .then((response) => {
            if (response.status !== 200) {
              message.error('Failed to remove registration.');
              return;
            }
            message.success('Registration removed successfully');
            onSuccess?.();
          })
          .catch(() => {
            message.error('Failed to remove registration.');
          });
      },
    });
  }

  return { showRemovePlayerSeasonRegistrationWithConfirm };
};
